// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m9vAa","fullView":"styles_fullView__3HYsH"};